<template lang="pug">
  span Dashboard
</template>

<script type="text/javascript">
export default {
  name: "Dashboard",
  data() {
    return {};
  },
};
</script>
